"use strict";
exports.__esModule = true;
var CRSBase = require("./crs");
var util_1 = require("@antv/util");
// @ts-ignore
exports.earth = util_1.mix({}, CRSBase.CRS, {
    wrapLng: [-180, 180],
    R: 6371000,
    distance: function (latlng1, latlng2) {
        var rad = Math.PI / 180;
        var lat1 = latlng1.lat * rad;
        var lat2 = latlng2.lat * rad;
        var sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2);
        var sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2);
        var a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return this.R * c;
    }
});
//# sourceMappingURL=earth.js.map